// extracted by mini-css-extract-plugin
export default {"wrapper":"OpenApp_wrapper__FbvJB"};